import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ShippingInstructionComponent} from './shipping-instruction.component';
import {ButtonModule} from 'primeng/button';
import {RippleModule} from 'primeng/ripple';
import {InputTextModule} from 'primeng/inputtext';
import {RadioButtonModule} from 'primeng/radiobutton';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CheckboxModule} from 'primeng/checkbox';
import {DropdownModule} from 'primeng/dropdown';
import {InputNumberModule} from 'primeng/inputnumber';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {FileUploadModule} from 'primeng/fileupload';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {BrowserModule} from '@angular/platform-browser';
import {AddressManagementComponent} from './address-management/address-management.component';
import {DialogModule} from 'primeng/dialog';
import {ToastModule} from 'primeng/toast';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {PreviewSiComponent} from './preview-si/preview-si.component';
import {ContainerDetailsComponent} from './container-details/container-details.component';
import {CargoDetailsComponent} from './cargo-details/cargo-details.component';
import {UserContactManagementComponent} from './user-contact-management/user-contact-management.component';


@NgModule({
    declarations: [ShippingInstructionComponent, AddressManagementComponent, PreviewSiComponent, ContainerDetailsComponent, CargoDetailsComponent, UserContactManagementComponent],
    imports: [
        CommonModule,
        BrowserModule,
        ButtonModule,
        RippleModule,
        InputTextModule,
        FormsModule,
        RadioButtonModule,
        ReactiveFormsModule,
        CheckboxModule,
        DropdownModule,
        InputNumberModule,
        AutoCompleteModule,
        FileUploadModule,
        InputTextareaModule,
        DialogModule,
        ToastModule,
        BreadcrumbModule,
    ],
})
export class ShippingInstructionModule {
}
